// Mock data for AssetWise Business Consultants

export const mockData = {
  hero: {
    title: "Your Trusted Partner for Loans & Property Solutions",
    subtitle: "Backed by 40+ years in banking and 100 years cumulative expertise, we provide reliable loan solutions and real estate advisory tailored to your needs.",
    cta: "Apply for Loan",
    ctaSecondary: "Book Consultation",
    image: "https://images.unsplash.com/photo-1672917196301-d5cac5c1a757"
  },
  
  intro: {
    text: "At AssetWise Business Consultants, we simplify your financial journey by offering end-to-end solutions for loans, legal advisory, and real estate investments. With decades of experience and strong industry knowledge, we ensure you get the best financial solutions with complete transparency and trust."
  },
  
  services: [
    {
      id: 1,
      title: "Loan Services",
      description: "Wide range of loan solutions tailored to your needs",
      icon: "BadgeIndianRupee",
      image: "https://customer-assets.emergentagent.com/job_finance-advisory-9/artifacts/jv7glf4c_ChatGPT%20Image%20Apr%2018%2C%202026%2C%2012_32_21%20PM.png",
      features: ["Home Loans", "Education Loans", "Car Loans", "Loan Against Property", "SME / Business Loans", "Project Finance", "Corporate Loans", "Gold Loans"]
    },
    {
      id: 2,
      title: "Real Estate Consulting",
      description: "Find high-quality properties and get the best deals at affordable prices",
      icon: "Building2",
      image: "https://customer-assets.emergentagent.com/job_finance-advisory-9/artifacts/8p50vgco_ChatGPT%20Image%20Apr%2018%2C%202026%2C%2012_37_37%20PM.png",
      features: ["Best Market Deals", "Verified Properties", "Smooth Documentation", "Investment Advisory", "Redevelopment"],
      description2: "Real estate services designed to simplify property buying and selling with expert guidance at every step. We assist with accurate property valuation, thorough title search, and end-to-end support for redevelopment projects. Our expertise also covers conveyance and deemed conveyance to ensure clear ownership and legal compliance. Experience seamless transactions with trusted advisory and efficient execution."
    },
    {
      id: 3,
      title: "Legal Advisory",
      description: "Expert guidance on loan documentation and property-related legal processes",
      icon: "Scale",
      image: "https://customer-assets.emergentagent.com/job_finance-advisory-9/artifacts/5dqckhil_ChatGPT%20Image%20Apr%2018%2C%202026%2C%2012_45_15%20PM.png",
      features: ["Loan Documentation", "Compliance & Verification", "Legal Liaisoning", "Conveyance & Deemed Conveyance"]
    }
  ],
  
  retailLoans: {
    intro: "Retail loans are designed to help individuals meet their personal financial goals with ease and flexibility. Whether you are planning to buy a home, fund education, purchase a vehicle, or manage short-term financial requirements, we provide end-to-end assistance in securing the right loan tailored to your needs.",
    types: [
      {
        title: "Home Loans",
        description: "Turn your dream of owning a home into reality with customised home loan solutions. We help you secure competitive interest rates, flexible repayment options, and quick approvals for buying, constructing, or renovating residential properties."
      },
      {
        title: "Mortgage Loans (Loan Against Property)",
        description: "Unlock the value of your existing property to meet personal or business financial needs. Mortgage loans offer higher loan amounts with longer tenures, making them ideal for expansion, medical expenses, or major investments."
      },
      {
        title: "Education Loans",
        description: "Invest in your future with education loans that cover tuition fees, living expenses, and other academic costs. We assist in securing loans for both domestic and international studies with student-friendly repayment options."
      },
      {
        title: "Vehicle Loans",
        description: "Own your dream vehicle with hassle-free financing solutions. Whether it's a car or a two-wheeler, we help you get quick approvals, minimal documentation, and attractive interest rates."
      },
      {
        title: "Gold Loans",
        description: "Get instant funds by leveraging your gold assets. Gold loans provide quick disbursement with minimal paperwork, making them a convenient option for urgent financial requirements."
      }
    ]
  },
  
  loanTypes: [
    {
      id: 1,
      name: "Home Loans",
      description: "Get the best deals for purchasing your dream home with competitive interest rates",
      interestRate: "Starting for as low as 7.25% p.a*",
      disclaimer: "Subject to CIBIL and documentation",
      features: ["Up to 90% loan amount", "Tenure up to 30 years", "Quick approval"],
      icon: "Home"
    },
    {
      id: 2,
      name: "Education Loans",
      description: "Secure your future with financial support for higher education",
      interestRate: "Starting from 9.0% p.a.",
      features: ["100% course fee coverage", "Moratorium period", "Tax benefits"],
      icon: "GraduationCap"
    },
    {
      id: 3,
      name: "Car Loans",
      description: "Easy and quick financing options for your vehicle purchase",
      interestRate: "Starting for as low as 8.5% p.a*",
      disclaimer: "Subject to CIBIL and documentation",
      features: ["Up to 90% on-road price", "Flexible tenure", "Minimal documentation"],
      icon: "Car"
    },
    {
      id: 4,
      name: "Loan Against Property",
      description: "Unlock the value of your property to meet financial needs",
      interestRate: "Starting for as low as 8.25% p.a*",
      disclaimer: "Subject to CIBIL and documentation",
      features: ["High loan-to-value ratio", "Competitive rates", "Quick disbursal"],
      icon: "Landmark"
    },
    {
      id: 5,
      name: "SME / Business Loans",
      description: "Flexible financing solutions to grow your business",
      interestRate: "Starting for as low as 8.25% p.a*",
      disclaimer: "Subject to CIBIL and documentation",
      features: ["Working capital support", "Equipment financing", "Business expansion"],
      icon: "Store"
    },
    {
      id: 6,
      name: "Project Finance",
      description: "Structured funding for large-scale projects",
      interestRate: "Customized rates",
      features: ["Large-scale financing", "Flexible terms", "Expert advisory"],
      icon: "Building"
    },
    {
      id: 7,
      name: "Corporate Loans",
      description: "Customized solutions for corporate financial requirements",
      interestRate: "Customized rates",
      features: ["Term loans", "Working capital", "Debt restructuring"],
      icon: "Building"
    },
    {
      id: 8,
      name: "Gold Loans",
      description: "Get instant funds by leveraging your gold assets",
      interestRate: "Starting from 9.5% p.a.",
      features: ["Quick disbursement", "Minimal paperwork", "Flexible repayment"],
      icon: "Coins"
    }
  ],
  
  about: {
    leaders: [
      {
        name: "Meena R Kakade",
        designation: "Banking Professional",
        email: "loans@assetwisebusiness.com",
        image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2",
        description: "A highly experienced banking professional with over 40+ years in banking and 30+ years in loan services, bringing deep industry expertise and strong financial insights.",
        experience: "40+ Years in Banking",
        specialization: "30+ Years in Loan Services"
      },
      {
        name: "Neeraj R Kakade",
        designation: "Property & Insurance Consultant",
        email: "property@assetwisebusiness.com",
        image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e",
        description: "Property & Insurance Consultant at AssetWise Business Consultants, focused on delivering client-centric solutions and building long-term trust.",
        experience: "15+ Years",
        specialization: "Financial & Real Estate Advisory"
      }
    ],
    mission: "To provide reliable, transparent, and efficient financial and real estate solutions that empower clients to make confident decisions."
  },
  
  whyChooseUs: [
    {
      id: 1,
      title: "40+ Years in Banking & 100 Years Cumulative",
      description: "Unmatched industry experience with deep expertise across generations",
      icon: "Award"
    },
    {
      id: 2,
      title: "Access to Multiple Banks",
      description: "Strong network with major banks and financial institutions nationwide",
      icon: "Building2"
    },
    {
      id: 3,
      title: "Tailored Solutions",
      description: "Personalized financial solutions based on your eligibility and requirements",
      icon: "Users"
    },
    {
      id: 4,
      title: "Transparent & Ethical Practices",
      description: "Complete transparency with no hidden charges or surprises",
      icon: "Eye"
    },
    {
      id: 5,
      title: "End-to-End Assistance",
      description: "Complete support from application to approval and beyond",
      icon: "Shield"
    },
    {
      id: 6,
      title: "Trusted Advisor",
      description: "Building long-term relationships based on trust and reliability",
      icon: "Heart"
    }
  ],
  
  testimonials: [
    {
      id: 1,
      name: "Rajesh Sharma",
      designation: "Home Loan Client",
      review: "Meena helped us secure our dream home with the best possible loan rates. Her guidance throughout the process was invaluable.",
      rating: 5
    },
    {
      id: 2,
      name: "Priya Deshmukh",
      designation: "SME Loan Client",
      review: "The support we received for our business expansion loan was exceptional. Quick processing and transparent communication.",
      rating: 5
    },
    {
      id: 3,
      name: "Amit Patil",
      designation: "Real Estate Client",
      review: "Found the perfect property at an amazing price. The legal support and negotiation skills saved us significantly.",
      rating: 5
    }
  ],
  
  contact: {
    phone: {
      meena: "+91 98331 79851",
      neeraj: "+91 96195 27810",
      office: "+91 22316 28431"
    },
    email: {
      meena: "loans@assetwisebusiness.com",
      neeraj: "property@assetwisebusiness.com",
      general: "info@assetwisebusiness.com"
    },
    address: "15/A3, Amar Vaishali Shanti Nagar CHS, Sec - 7, Mira Road (East), Thane – 401107",
    whatsapp: "+91 96195 27810",
    hours: "11:00 AM - 8:00 PM",
    workingDays: "Sunday to Saturday (Monday Off)",
    responseTime: "We respond within 24 hours"
  },
  
  stats: [
    { label: "Years in Banking", value: "40+" },
    { label: "Cumulative Experience", value: "100+ Yrs" },
    { label: "Happy Clients", value: "50+" },
    { label: "Loans Processed", value: "₹100+ Cr" }
  ]
};
